import { CssSelector } from '@angular/compiler';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTabGroup as MatTabGroup } from '@angular/material/legacy-tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiResult } from '@app/shared/model/apiresult';
import { Guid } from 'guid-typescript';
import { NgxPermissionsService } from 'ngx-permissions';
import { $ } from 'protractor';
import { EComplianceTabIndex } from './constants/eComplianceTabIndex';
import { IStudent } from './model/student';
import { StudentAthleteService } from './services/student-athlete.service';

@Component({
  selector: 'app-compliance',
  templateUrl: 'compliance.component.html'
})

export class ComplianceComponent implements OnInit {
   public WRITE_COMPLIANCE_STUDENT_ATHLETE_INFORMATION:boolean=false;
   public WRITE_COMPLIANCE_CONTACT_INFORMATION:boolean=false;
   public WRITE_COMPLIANCE_SEASON_DATA:boolean=false;
   public WRITE_COMPLIANCE_TRANSFER_SEASON_DATA:boolean=false;
   public WRITE_COMPLIANCE_OFFICIAL_VISIT:boolean=false;
   public WRITE_COMPLIANCE_DOCUMENTS:boolean=false;
   public WRITE_COMPLIANCE_NOTES:boolean=false;
   public WRITE_COMPLIANCE_ELIGIBILITY_FIELDS:boolean=false;
  public student: IStudent;
  public tabIndex: string;
  @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;
  constructor(private _route:Router, 
    private _activeroute: ActivatedRoute,
     private _studentathleteservice: StudentAthleteService,
    private _permissionservice: NgxPermissionsService
    ) { }
  ngOnInit() {
    this._permissionservice.hasPermission("read:compliance").then(readCompliance=>{
      if(readCompliance){
        this.student = null; 
        this._activeroute.queryParams.subscribe(params => {
          if(params.id!=undefined){
            this.get(params.id);
          }     
        });
        this.getPermission();        
      }
      else{
        this._route.navigate(['/401']);       
      }
    });      
  }
  private get(id: Guid) {
    this._studentathleteservice.get(id).subscribe((result: ApiResult<IStudent>) => {
      if (result.validationErrors == null && result.value != null) {
        this.student = result.value;
        switch (this._activeroute.snapshot.params.mode)
         {
            case "notes":
              this.tabIndex = EComplianceTabIndex.Notes;
              break;
            case "documents":
              this.tabIndex = EComplianceTabIndex.Documents;
              break;
        }        
      }
    }, error => console.error(error));
  }
 
  getPermission() {         
    this._permissionservice.hasPermission("write:compliance_student_athlete_information").then(data=>{
      this.WRITE_COMPLIANCE_STUDENT_ATHLETE_INFORMATION=data;
    });
    this._permissionservice.hasPermission("write:compliance_contact_information").then(data=>{
      this.WRITE_COMPLIANCE_CONTACT_INFORMATION=data;
    });
    this._permissionservice.hasPermission("write:compliance_season_data").then(data=>{
      this.WRITE_COMPLIANCE_SEASON_DATA=data;      
    });
    this._permissionservice.hasPermission("write:compliance_transfer_season_data").then(data=>{
      this.WRITE_COMPLIANCE_TRANSFER_SEASON_DATA=data;
    });
    this._permissionservice.hasPermission("write:compliance_official_visit").then(data=>{
      this.WRITE_COMPLIANCE_OFFICIAL_VISIT=data;
    });
    this._permissionservice.hasPermission("write:compliance_documents").then(data=>{
      this.WRITE_COMPLIANCE_DOCUMENTS=data;
    });
    this._permissionservice.hasPermission("write:compliance_notes").then(data=>{
      this.WRITE_COMPLIANCE_NOTES=data;
    });
    this._permissionservice.hasPermission("write:compliance_eligibilityfields").then(data=>{
      this.WRITE_COMPLIANCE_ELIGIBILITY_FIELDS=data;
    });
  }  
}